import { render, staticRenderFns } from "./biddingViewFile.vue?vue&type=template&id=372647d3&scoped=true"
import script from "./biddingViewFile.vue?vue&type=script&lang=js"
export * from "./biddingViewFile.vue?vue&type=script&lang=js"
import style0 from "./biddingViewFile.vue?vue&type=style&index=0&id=372647d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372647d3",
  null
  
)

export default component.exports